import React from "react";
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Avatar, Box, Typography } from "@mui/material";
import styles from "./style";
import { useNavigate } from "react-router-dom";
import CustomPagination from "../../../../components/CustomPagination";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { ReactComponent as Edit } from "../../../../assets/images/edit.svg";
import Modal from "../../../../components/Modal";
import { formatDate } from "../../../../utils/DateFormat";

const TravelallowancesList = ({ data, page, setPage, total, setDeleteOpen, setOpen, deleteOpen, handleEdit, DeleteCommission }) => {
  const navigate = useNavigate()
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [value, setValue] = useState();

  const handleNavigate = (item) => {
    navigate("/dashboard/viewTravelAllowances", { state: { item } })
  }

  const deleteData = (item) => {
    setValue(item);
  }


  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.TableHead}>Name</TableCell>
              <TableCell sx={styles.TableHead}>kilometer</TableCell>
              <TableCell sx={styles.TableHead}>Type</TableCell>
              <TableCell sx={styles.TableHead}>Total</TableCell>
              <TableCell sx={styles.TableHead}>Taxable%</TableCell>
              <TableCell sx={styles.TableHead}>Status</TableCell>
              <TableCell sx={styles.TableHead}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Typography variant="h6">No data</Typography>
                </TableCell>
              </TableRow>
            ) : (
              data.map((item, index) => (
                <TableRow key={index}>
                  <TableCell sx={styles.tableAvtardata} onClick={() => handleNavigate(item)}>
                    <Avatar src={item?.employeeDetails[0]?.personalInfo?.image} sx={{ mr: "8px" }} /><Box >
                      <Typography sx={styles.name}>{item?.employeeDetails[0]?.personalInfo?.firstName} {item?.employeeDetails[0]?.personalInfo?.surName}</Typography>
                      <Typography sx={styles.mail}>{item?.employeeDetails[0]?.personalInfo?.email}</Typography>
                    </Box>       </TableCell>
                  <TableCell sx={styles.tabledata}>{item?.kilometer}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.travelType}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.totalAmt}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.taxablePercentage}</TableCell>
                  <TableCell sx={{ borderBottom: 0 }}><Box sx={{
                    border: `1px solid ${item.status === "Approved" ? "#28AA4A" :
                      item.status === "Rejected" ? "#FF0000" :
                        item.status === "Pending" ? "#F4B63F" :
                          item.status === "Weekend" ? "#00ABF4" :
                            "black"
                      }`,
                    borderRadius: "30px", display: "flex", justifyContent: "center", alignItems: "center", py: "5px", px: "14px", fontSize: "12px", width: "fit-content", textTransform: "capitalize",
                    color: `${item.status === "Approved" ? "#28AA4A" :
                      item.status === "Rejected" ? "red" :
                        item.status === "Pending" ? "#F4B63F" :
                          item.status === "Weekend" ? "#00ABF4" :
                            "black"
                      }`
                  }}>{item.status}</Box></TableCell>
                  <TableCell sx={styles.tableData} >
                    <Box sx={styles.tableActiondata}>
                      <Edit onClick={() => { setOpen(true); handleEdit("edit", item) }} />
                      <DeleteOutlineIcon sx={styles.deleteIcon} onClick={() => {
                        deleteData(item?._id), setDeleteOpen(true);
                      }}
                      />
                    </Box>
                  </TableCell>
                </TableRow>
              )))}
          </TableBody>
        </Table>
        {data &&
          <CustomPagination
            pageCount={total}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            totalItems={data.length}
          />}

      </TableContainer>
      <Modal open={deleteOpen} setOpen={setDeleteOpen} deletetText={"Delete"} cancelText={"Cancel"} title={"Delete Employee"} handleDelete={() => { DeleteCommission(value); setDeleteOpen(false) }}>
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>
        </Box>
      </Modal>

    </>
  );
};
export default TravelallowancesList;
